module.exports = "../dist/frontend/icons/logo/footer-blue.svg?c4db176d7da9b51eb7fac33207ca1c20";